module.exports = __webpack_public_path__ + "static/media/close-black.94a839a3.svg";